import { render } from "./Error404.vue?vue&type=template&id=2d23e544&scoped=true&ts=true"
import script from "./Error404.vue?vue&type=script&lang=ts"
export * from "./Error404.vue?vue&type=script&lang=ts"

import "./Error404.vue?vue&type=style&index=0&id=2d23e544&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d23e544"]])

export default __exports__